/**
 * @module estrutura/ui/estruturaui
 */

import { EditorUI, Plugin } from 'ckeditor5/src/core';
import { addListToDropdown, createDropdown, Model } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';
import '../../theme/estrutura.pcss';
import EstruturaEditing from '../estruturaediting';
import {
	Dispositivo
} from '../models';

const ESTRUTURA = 'estrutura';

/**
 * The estrutura UI plugin.
 *
 * It introduces the `'estrutura'` button and toolbar.
 *
 * @extends {Plugin}
 */
export default class EstruturaUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'EstruturaUI';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ EstruturaEditing ];
	}

	/**
	 * @inheritDoc
	 */
	init() {
		/**
		 * @type {EditorUI}
		 */
		const editor = this.editor;
		const label = "Dispositivo";
		const dropdownTooltip = "Adicionar dispositivo";
		/**
		 * @type {Array<Dispositivo>}
		 */
		const options = editor.config.get( ESTRUTURA ).dispositivos || [];
		const command = editor.commands.get( ESTRUTURA );

		// Register UI component.
		editor.ui.componentFactory.add( ESTRUTURA, locale => {
			const dropdownView = createDropdown( locale );

			const itemDefinitions = new Collection();
			for ( const option of options ) {
				const def = {
					type: 'button',
					model: new Model( {
						commandName: ESTRUTURA,
						commandParam: option.codigo,
						label: option.descricao,
						withText: true
					} )
				};
				itemDefinitions.add( def );
			}

			addListToDropdown( dropdownView, itemDefinitions );

			dropdownView.buttonView.set( {
				label: label,
				tooltip: dropdownTooltip,
				withText: true
			} );

			dropdownView.extendTemplate( {
				attributes: {
					class: 'ck-estrutura-dropdown'
				}
			} );

			dropdownView.bind( 'isEnabled' ).to( command );

			this.listenTo( dropdownView, 'execute', evt => {
				editor.execute( evt.source.commandName, {
					dispositivo: evt.source.commandParam
				} );
				editor.editing.view.focus();
			} );

			return dropdownView;
		} );
	}
}
